export default "__VITE_ASSET__vtJlLNor__"